import React from 'react'
import { Box, Text, Flex } from '@chakra-ui/core'
import { useFormContext } from 'react-hook-form'
import { UploadImageField } from '../fileds/UploadImageField'
import { UploadVideoField } from '../fileds/UploadVideoField'
import { PopFormValues } from 'components/Pop/types'
import useLocaleText from 'components/useLocaleText'

// import { UploadAudioField } from './UploadAudioField'

export const UploadMediaSection = () => {
  const { watch } = useFormContext<PopFormValues>()
  const popImageUrl = watch('data.pop_image_url') as string
  const popVideoUrl = watch('data.pop_video_url') as string
  const popAudioUrl = watch('data.pop_audio_url') as string

  const isImageUploaded = Boolean(popImageUrl)
  const isVideoUploaded = Boolean(popVideoUrl)
  const isAudioUploaded = Boolean(popAudioUrl)

  const enhance_pop_with_media_files = useLocaleText('enhance_pop_with_media_files', true)

  return (
    <Box>
      <Text fontSize="14px" fontWeight="bold" color="gray.500" mt={4} mb={2}>
        {enhance_pop_with_media_files}
      </Text>
      <Flex flexDir="column" style={{ gap: '10px' }}>
        <Box
          opacity={isVideoUploaded || isAudioUploaded ? 0.4 : 1}
          pointerEvents={isVideoUploaded || isAudioUploaded ? 'none' : 'auto'}
        >
          <UploadImageField />
        </Box>

        <Box
          opacity={isImageUploaded || isAudioUploaded ? 0.4 : 1}
          pointerEvents={isImageUploaded || isAudioUploaded ? 'none' : 'auto'}
        >
          <UploadVideoField />
        </Box>
        {/* <Box
          opacity={isImageUploaded || isVideoUploaded ? 0.4 : 1}
          pointerEvents={isImageUploaded || isVideoUploaded ? 'none' : 'auto'}
        >
          <UploadAudioField />
        </Box> */}
      </Flex>
    </Box>
  )
}
